import { React, useState } from "react";
import request from "../../../Helpers/API";
import {
    Modal,
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useRef } from "react";
import { LoaderScreen } from "../../components/LoaderScreen";

export const CargaArchivosInventarioModal = ({ open, onClose, auditoria, tipoArchivo, sucursal, onActualizar }) => {
    const [archivo, setArchivo] = useState(null);
    const fileInputRef = useRef(null);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleClose = () => {
        setArchivo(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }

        onClose();
    };

    const convertirBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];

                resolve(base64);
            };

            reader.onerror = error => reject(error);
        });
    };

    const onCargarArchivo = async () => {
        try {

            if (!archivo) {
                Swal.fire("CARGA DE ARCHIVO", "Selecciona un archivo", "warning");
                return;
            }

            setLoader({ ...loader, mostrar: true });

            const documentoBase64 = await convertirBase64(archivo);

            const post = {
                folio: auditoria,
                id_usuario: 0,
                id_sucursal: sucursal,
                documento: documentoBase64,
                extension: archivo.name.split(".").pop(),
                tipo_ajuste: tipoArchivo
            };

            const endpoint =
                tipoArchivo === "I"
                    ? "CargaInventario/CargarInventarioFisico"
                    : "CargaInventario/CargarInventarioAjustes";

            await request.post(endpoint, post)
                .then((result) => {

                    if (result?.mensaje !== "OK" || result?.resultado !== 0) {
                        Swal.fire(
                            "CONTEO",
                            result?.mensaje || "Ocurrió un problema al cargar el archivo",
                            "warning"
                        );
                        setLoader({ ...loader, mostrar: false });
                        return;
                    }

                    setLoader({ ...loader, mostrar: false });

                    Swal.fire({
                        title: "CARGA DE ARCHIVO",
                        text: "Archivo procesado con éxito",
                        icon: "success",
                    });

                    handleClose();
                    onActualizar()
                }).catch((error) => {
                    const mensaje =
                        error?.response?.data ||
                        error?.Mensaje ||
                        "Error al guardar el archivo.";

                    Swal.fire("Auditoria", mensaje, "error");
                    setLoader({ ...loader, mostrar: false });
                });
            ;

        } catch (error) {

            setLoader({ ...loader, mostrar: false });

            Swal.fire(
                "CARGA DE ARCHIVO",
                JSON.stringify(error?.response?.data || error),
                "error"
            );
        }
    };

    const titulo = tipoArchivo === "I"
        ? "CARGA DE INVENTARIO FÍSICO"
        : tipoArchivo === "T"
            ? "CARGA DE INVENTARIO EN TRÁNSITO"
            : tipoArchivo === "S"
                ? "CARGA DE INVENTARIO POR SURTIR"
                : "CARGA DE ARCHIVOS DE INVENTARIO";

    // console.log(auditoria, archivo)

    return (
        <>
            <LoaderScreen loader={loader} />
            <Modal open={open} onClose={handleClose}>
                <div className="cargar-archivo-inventario-modal-formulario">
                    <div className="cargar-archivo-inventario-modal-plantilla">
                        <div
                            className="cargar-archivo-inventario-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={titulo}
                                className_main={1}
                                className={"cargar-archivo-inventario-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={handleClose}>
                                    X
                                </div>
                                <div className={`cargar-archivo-inventario-modal`}>
                                    {/* <div className="cargar-archivo-inventario-modal-selector">
                                        <button
                                            className={`tipo-btn ${tipoCarga === "Inventario" ? "active" : ""}`}
                                            onClick={() => setTipoCarga("Inventario")}
                                        >
                                            Cargar Inventario Físico
                                        </button>

                                        <button
                                            className={`tipo-btn ${tipoCarga === "Transito" ? "active" : ""}`}
                                            onClick={() => setTipoCarga("Transito")}
                                        >
                                            Cargar Inventario en Tránsito
                                        </button>

                                        <button
                                            className={`tipo-btn ${tipoCarga === "Surtido" ? "active" : ""}`}
                                            onClick={() => setTipoCarga("Surtido")}
                                        >
                                            Cargar Inventario por Surtir
                                        </button>
                                    </div> */}
                                    <div className="cargar-archivo-inventario-modal-container">
                                        <div className="select-archivo">
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                hidden
                                                accept=".csv,.xlsx"
                                                onChange={(e) => setArchivo(e.target.files[0])}
                                            />

                                            <div
                                                className="drop-zone"
                                                onClick={() => fileInputRef.current.click()}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={(e) => {
                                                    e.preventDefault();
                                                    setArchivo(e.dataTransfer.files[0]);
                                                }}
                                            >
                                                <p>📁 Arrastra o haz clic para subir archivo</p>

                                                {archivo && (
                                                    <div className="archivo-seleccionado">
                                                        {archivo.name}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cargar-archivo-inventario-modal-buttons">
                                        <button
                                            className="cargar-archivo-inventario-modal-button-cargar"
                                            onClick={() =>
                                                onCargarArchivo()
                                            }
                                        >
                                            Cargar Archivo
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
